
import { get, post,put } from '../utils/apiHelper'
export const login = (data) => {
    return post('/user/login', data)
}
export const signUp = (data) => {
    return post('/user/add-user', data)
}


export const signUpEndUser = (data) => {
    return post('/user/add-end-user', data)
}

export const loginEndUser = (data) => {
    return post('/user/end-user-login', data);

}
export const getRoomUsers = ()=>{
    return get('/user/room-users');
}
export const isEmailExist = (data) => {
    return post('/user/email', data);
}
export const validateToken = () => {
    return get('/user/validate/token')
}


export const signedUser = (body) => {
    return post('/user/sign-user', body);
}

export const getUserById = (id) => {
    return get(`/user/user-details/${id}`);
}
export const getAllAdmins = () => {
    return get(`/user/admin-list`);
}
export const deleteAdmin = (id) => {
    return get(`/user/admin-delete/${id}`);
}

export const updateUser = (id, data) => {
    return put(`/user/update-user/${id}`, data);
}
export const getAllUsers = () => {
    return get(`/user/getAlluser`);
}
export const getVenueDetail = (id) =>{
    return get(`/venue/${id}`)
}